import dayjs from 'dayjs';

export function getCurrentMonth() {
  return dayjs().startOf('month').unix();
}
